module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Rekenmodule")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "limiet"
    }
  }, [_vm._v("Limiet (m):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.limiet),
      expression: "limiet",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "limiet"
    },
    domProps: {
      "value": (_vm.limiet)
    },
    on: {
      "change": function($event) {
        _vm.limiet = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.limietUitLijst),
      expression: "limietUitLijst",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.limietUitLijst = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.limieten), function(l) {
    return _c('option', {
      domProps: {
        "value": l.limiet
      }
    }, [_vm._v(_vm._s(l.tekst))])
  })), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "limiet"
    }
  }, [_vm._v("Wielomtrek (m):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.omtrek),
      expression: "omtrek",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "limiet"
    },
    domProps: {
      "value": (_vm.omtrek)
    },
    on: {
      "change": function($event) {
        _vm.omtrek = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.omtrekUitLijst),
      expression: "omtrekUitLijst",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.omtrekUitLijst = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.banden), function(l) {
    return _c('option', {
      domProps: {
        "value": l.omtrek
      }
    }, [_vm._v(_vm._s(l.naam))])
  })), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.narrowWide),
      expression: "narrowWide"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.narrowWide) ? _vm._i(_vm.narrowWide, null) > -1 : (_vm.narrowWide)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.narrowWide,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.narrowWide = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.narrowWide = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.narrowWide = $$c
        }
      }
    }
  }), _vm._v("Narrow-Wide")])])])]), _vm._v(" "), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Mogelijke verzetten:")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.verzetten), function(v) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(v.blad))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.krans))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.marge))])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Jeugdverzetten")]), _vm._v(" "), _c('p', [_vm._v("Bij wielrennen, veldrijden en op de baan krijgen jeugdrenners te maken met regels die het gebruikte verzet beperken")]), _vm._v(" "), _c('p', [_vm._v("We zien dat dit vaak problemen of uitdagingen oplevert. Hoe werkt het? Voor de categorie en discipline waar je in rijdt,\n        geldt een maximum. Dit is een afstand in centimeters die je met één hele pedaalomwenteling op het zwaarste verzet af mag leggen.")]), _vm._v(" "), _c('p', [_vm._v("Vaak wordt nog gedacht dat alleen maar het verzet van belang is, maar om de maat van de band is van belang.")]), _vm._v(" "), _c('p', [_vm._v("Met een 25mm band is de omtrekt van het wiel groter dan met een 23mm band. En zelfs kan de druk van belang zijn.\n          Dit laatste zie je vooral in het veldrijden, waar vaak met heel lage bandendruk wordt gereden. Ook moet je er\n        rekening mee houden dat de de omtrent ook verschillend kan zijn tussen diverse banden van verschillende types\n      of merken met dezelfde maatvoering")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Opmeten")]), _vm._v(" "), _c('p', [_vm._v("Zelfs als je wil gaan rekenen met verzetten, zul je eerst de omtrek van het wiel met band op moeten meten.\n          En het beste doe je dat door met de fiets door een smal gootje te rijden. Ze het ventiel van het achterwiel\n          onder, markeer dat punt en rij dan tot het ventiel weer onder staat. Markeer ook dat punt en meet de afstand\n          tussen beide punten")]), _vm._v(" "), _c('p', [_vm._v("Voor de rekenmodule die hiernaast staat hebben wij een paar banden opgemeten, zodat je een goede indicatie\n            krijgt van de omtrek.")]), _vm._v(" "), _c('p', [_vm._v("In de module kun je ook kiezen tussen 'narrow-wide' en 'normaal' kettingblad. Een narrow-wide kettingblad\n            is gemaakt om zonder derailleur als enkel kettingblad gebruikt te kunnen worden. Dit heeft allerlei voordelen,\n            maar ook één belangrijke beperking: de techniek heeft tot gevolg dat het aantal tanden altijd even is.")]), _vm._v(" "), _c('p', [_vm._v("De module geeft uiteindelijk een goede indicatie, maar zekerheid heb je pas als je alles zelf opmeet of op\n              laat meten. Bij fietsen waar wij verzetten en/of banden monteren, meten wij als dat gevraagd wordt de\n              waardes op.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Blad")]), _vm._v(" "), _c('th', [_vm._v("Krans")]), _vm._v(" "), _c('th', [_vm._v("Marge (cm)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6674962e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Verzetten.vue
// module id = 20
// module chunks = 0